import { Autocomplete, Button, Dialog, DialogActions, DialogContent, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useGetAllCustomFields } from '../../../services/react-query/event_templates/useGetAllCustomFields';

interface Props {
  open: boolean;
  onClose: () => void;
  onInsert: (fieldLabel: string) => void;
}

export default function EventCustomFieldInsertModal({ open, onClose, onInsert }: Props) {
  const [selected, setSelected] = useState<string | null>(null);
  const { data, isLoading } = useGetAllCustomFields({ enabled: open });

  const customFields = data?.data ?? [];

  useEffect(() => {
    if (!open) setSelected(null);
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogContent sx={{ pt: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Autocomplete
          options={customFields}
          loading={isLoading}
          value={selected}
          onChange={(_, val) => setSelected(val)}
          getOptionLabel={(option) => option}
          renderInput={(params) => <TextField {...params} label="Select Event Custom Field" />}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={() => {
            if (selected) onInsert(selected);
            onClose();
          }}
          variant="contained"
          disabled={!selected}
        >
          Insert
        </Button>
      </DialogActions>
    </Dialog>
  );
}
